// Email-gated downloads: a[data-gated="true"] opens #downloadModal; on submit
// the email goes to the contact API (and Brevo if opted in), then the file in
// the link's href downloads. Restored from the pre-static insights.js modal.
(function () {
  var API = "https://ito1sidcvb.execute-api.eu-north-1.amazonaws.com/prod/contact";
  var BREVO =
    "https://7ef60359.sibforms.com/serve/MUIFAPRl-eXkIKpwiXSHTFN8IsyqQhPIaJMeVY0OXpcZVs4yM9vFyPt8d6vfHH0Oc7WSUGVIC1v-oS499QgH0KdlyaAFXQYx3To2uPP-kgU1uuNdAezu2mdM1ZnYrxh-cIQAobsyWj3IUGI_FXwNEGGW5EqWWIcP3tkzyMzH0b0Zwgg0rMfwID2YB2nPUBcMVujHU2GQCenVcoj3";

  var modal = document.getElementById("downloadModal");
  var form = document.getElementById("downloadForm");
  if (!modal || !form) return;
  var emailEl = document.getElementById("downloadEmail");
  var newsletterEl = document.getElementById("downloadNewsletter");
  var consentEl = document.getElementById("downloadConsent");
  var submitBtn = form.querySelector('button[type="submit"]');

  function open(url, source) {
    form.dataset.url = url;
    form.dataset.source = source || "Gated Download: " + url;
    syncSubmit();
    modal.style.display = "flex";
    document.body.style.overflow = "hidden";
    emailEl.focus();
  }
  function close() {
    modal.style.display = "none";
    document.body.style.overflow = "";
  }

  document.querySelectorAll('a[data-gated="true"]').forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      open(link.getAttribute("href"), link.dataset.source);
    });
  });
  var closeBtn = document.getElementById("closeModal");
  if (closeBtn) closeBtn.addEventListener("click", close);
  modal.addEventListener("click", function (e) {
    if (e.target === modal) close();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.style.display !== "none") close();
  });

  // The PDF button stays disabled until the consent box is ticked.
  function syncSubmit() {
    submitBtn.disabled = !consentEl.checked;
  }
  syncSubmit();
  consentEl.addEventListener("change", syncSubmit);
  form.addEventListener("reset", function () {
    setTimeout(syncSubmit, 0);
  });

  form.addEventListener("submit", async function (e) {
    e.preventDefault();
    var email = emailEl.value.trim();
    var url = form.dataset.url;
    if (!email || !emailEl.checkValidity() || !consentEl.checked || !url) {
      form.reportValidity();
      return;
    }
    // No separate newsletter box: the consent box is the opt-in, as on the webinar forms.
    var subscribe = newsletterEl ? newsletterEl.checked : consentEl.checked;
    submitBtn.disabled = true;

    if (window.posthog) {
      window.posthog.identify(email);
      window.posthog.capture("gated_content_download", {
        email: email,
        file_url: url,
        subscribed_newsletter: subscribe,
        location: "insights_modal",
      });
      if (subscribe) {
        window.posthog.capture("newsletter_subscribed", {
          email: email,
          source: "gated_download_modal",
          context: "Downloaded: " + url,
        });
      }
    }

    try {
      await fetch(API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email,
          source: form.dataset.source,
          subscribe_newsletter: subscribe,
        }),
      });
      if (subscribe) {
        var body = new URLSearchParams();
        body.append("EMAIL", email);
        body.append("email_address_check", "");
        body.append("locale", window.forsytLang || "en");
        await fetch(BREVO, { method: "POST", body: body, mode: "no-cors" });
      }
    } catch (err) {
      console.error("Gated download wiring failed:", err);
    }

    // Download regardless of the tracking outcome, as before.
    var a = document.createElement("a");
    a.href = url;
    a.download = url.split("/").pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    form.reset();
    submitBtn.disabled = true;
    close();
  });
})();
